import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import Select from "react-select";
import useFetch from "../../hooks/useFetch";
import { fetchDataFromApi } from "../../utils/api";
import "./Explore.scss";
import { ThreeDots } from  'react-loader-spinner';
import Card from "../../components/card/Card";

let filters = {};

const sortbyData = [
    { value: "popularity.desc", label: "Popularity Descending" },
    { value: "popularity.asc", label: "Popularity Ascending" },
    { value: "vote_average.desc", label: "Rating Descending" },
    { value: "vote_average.asc", label: "Rating Ascending" },
    {
        value: "primary_release_date.desc",
        label: "Release Date Descending",
    },
    { value: "primary_release_date.asc", label: "Release Date Ascending" },
    { value: "original_title.asc", label: "Title (A-Z)" },
];

const Explore = () => {
  const [data, setData] = useState(null);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);
  const [genre, setGenre] = useState(null);
  const [sortby, setSortby] = useState(null);
  const { mediaType } = useParams();

  const { data: genresData } = useFetch(`/genre/${mediaType}/list`);

  const fetchInitialData = () => {
      setLoading(true);
      fetchDataFromApi(`/discover/${mediaType}`, filters).then((res) => {
          setData(res);
          setPageNum((prev) => prev + 1);
          setLoading(false);
      });
  };

  const fetchNextPageData = () => {
      fetchDataFromApi(
          `/discover/${mediaType}?page=${pageNum}`,
          filters
      ).then((res) => {
          if (data?.results) {
              setData({
                  ...data,
                  results: [...data?.results, ...res.results],
              });
          } else {
              setData(res);
          }
          setPageNum((prev) => prev + 1);
      });
  };

  useEffect(() => {
      filters = {};
      setData(null);
      setPageNum(1);
      setSortby(null);
      setGenre(null);
      fetchInitialData();
  }, [mediaType]);

  const onChange = (selectedItems, action) => {
      if (action.name === "sortby") {
          setSortby(selectedItems);
          if (action.action !== "clear") {
              filters.sort_by = selectedItems.value;
          } else {
              delete filters.sort_by;
          }
      }

      if (action.name === "genres") {
          setGenre(selectedItems);
          if (action.action !== "clear") {
              let genreId = selectedItems.map((g) => g.id);
              genreId = JSON.stringify(genreId).slice(1, -1);
              filters.with_genres = genreId;
          } else {
              delete filters.with_genres;
          }
      }

      setPageNum(1);
      fetchInitialData();
  };


  return (
    <div className={"explorePage"}>
            <div className={"wrapper"}>
                <div className={"pageHeader"}>
                    <div className={"pageTitle"}>
                        {mediaType === "tv"
                            ? "Explore TV Shows"
                            : "Explore Movies"}
                    </div>
                    <div className={"filters"}>
                        <Select
                            isMulti
                            name="genres"
                            value={genre}
                            closeMenuOnSelect={false}
                            options={genresData?.genres}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            onChange={onChange}
                            placeholder="Select genres"
                            className={"react-select-container genresDD"}
                            classNamePrefix="react-select"
                        />
                        <Select
                            name="sortby"
                            value={sortby}
                            options={sortbyData}
                            onChange={onChange}
                            isClearable={true}
                            placeholder="Sort by"
                            className={"react-select-container sortbyDD"}
                            classNamePrefix="react-select"
                        />
                    </div>
                </div>
                {loading && <div className="center">
                    <ThreeDots  
                        height="80" 
                        width="80" 
                        radius="9"
                        color="#1e90ff" 
                        ariaLabel="three-dots-loading"
                        visible={true}
                    />
                </div>}
                {!loading && (
                    <>
                        {data?.results?.length > 0 ? (
                            <InfiniteScroll
                                className="content"
                                dataLength={data?.results?.length || []}
                                next={fetchNextPageData}
                                hasMore={pageNum <= data?.total_pages}
                                loader={<div className="center">
                                <ThreeDots  
                                    height="80" 
                                    width="80" 
                                    radius="9"
                                    color="#1e90ff" 
                                    ariaLabel="three-dots-loading"
                                    visible={true}
                                />
                            </div>}
                            >
                                {data?.results?.map((item, index) => {
                                    if (item.media_type === "person") return;
                                    return (
                                        <Card
                                            key={index}
                                            data={item}
                                            mediaType={mediaType}
                                        />
                                    );
                                })}
                            </InfiniteScroll>
                        ) : (
                            <span className={"resultNotFound"}>
                                Sorry, Results not found!
                            </span>
                        )}
                    </>
                )}
            </div>
        </div>
  )
}

export default Explore;